import VehicleMenu from './VehicleMenu';

export default VehicleMenu;
